import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontRoboto, fontRobotoCondensed } from "shared/lib/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  block-size: 660px;
  max-inline-size: 375px;
  padding-block: 37px 20px;
  padding-inline: 20px;

  border: 1px solid #e5e5e5;
  border-radius: 8px;

  background-color: #ffffff;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;

  margin-block-end: 26px;
`;

export const Title = styled.div`
  color: #000000;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 16px;
  text-transform: uppercase;
`;

export const List = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 10px;

  overflow: auto;
`;

export const ItemType = styled.span`
  grid-area: type;

  margin-block-end: 2px;

  color: #d3d3d3;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
`;

export const ItemName = styled.span`
  grid-area: name;

  color: #d3d3d3;
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRoboto};
`;

export const ItemIcon = styled.div`
  grid-area: icon;

  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 24px;
  block-size: 24px;

  cursor: pointer;
`;

type ListItemProps = {
  $isSelected?: boolean;
};
export const ListItem = styled.div<ListItemProps>`
  display: grid;
  grid:
    "type icon" auto
    "name icon" auto / 1fr 24px;
  align-items: center;

  padding-block: 8px;
  padding-inline: 16px;

  border: 1px solid #cccccc;

  background-color: #ffffff;

  user-select: none;

  ${props =>
    props.$isSelected &&
    css`
      border-color: #ffca05;

      background-color: #ffca05;

      ${ItemType},
      ${ItemName} {
        color: #000000;
      }
    `};
`;

export const ButtonContainer = styled.div`
  padding-block-start: 20px;

  border-block-start: 1px solid #e5e5e5;
`;

export const Button = styled.div`
  padding-block: 15px;

  color: #ffffff;
  font-size: 16px;
  font-family: ${fontRoboto};
  text-align: center;
  text-transform: uppercase;

  border-radius: 4px;

  background-color: #001246;

  cursor: pointer;
`;
